import { render, staticRenderFns } from "./confirmDeleteDialog.vue?vue&type=template&id=612365b4&scoped=true"
import script from "./confirmDeleteDialog.vue?vue&type=script&lang=js"
export * from "./confirmDeleteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612365b4",
  null
  
)

export default component.exports